import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import DownloadIcon from "@icons/myicons/document-file-download.svg?react";
import { RangeSelectorControlProps } from "@hooks";
import { useDownloadTransactions } from "@api/v1/hooks/useTransactions";
import { createObjectUrl, downloadFile } from "@helpers/files";

interface Props {
  accountId: number;
  range: RangeSelectorControlProps["range"];
  currency?: string;
  order?: string[];
  fullWidth?: boolean;
  compact?: boolean;
}

export const AccountTransactionsExportButton = ({
  accountId,
  range,
  currency,
  order,
  fullWidth,
  compact = false,
}: Props) => {
  const { t } = useTranslation();

  const { mutate: downloadTransactions } = useDownloadTransactions(
    {
      format: "csv",
      accountId: [accountId],
      minDate: range.startDate?.toISOString(),
      maxDate: range.endDate.toISOString(),
      order,
      displayCurrency: currency,
    },
    {
      onSuccess: (data) => {
        const url = createObjectUrl(data, "text/csv");
        downloadFile(url, "transactions.csv");
      },
    }
  );

  return (
    <Button
      size="small"
      variant="outlined"
      fullWidth={fullWidth}
      startIcon={<DownloadIcon width="20px" height="20px" />}
      onClick={() => downloadTransactions(undefined)}
      aria-label={
        compact ? t("singleAccountPage.protocolTable.export") : undefined
      }
      sx={{ flexShrink: 0 }}
    >
      {compact
        ? t("components.depotsStatistic.tabs.exportShort")
        : t("singleAccountPage.protocolTable.export")}
    </Button>
  );
};
